import nwfaSeals from "@/assets/nwfa-certification-seals.png";

const TrustBar = () => (
  <section aria-label="Professional credentials" className="bg-background px-5 py-7 md:px-8 md:py-8 lg:px-12">
    <div className="mx-auto grid w-full max-w-[1180px] grid-cols-2 items-center gap-x-5 gap-y-6 lg:grid-cols-[minmax(180px,0.8fr)_minmax(480px,2fr)_minmax(180px,0.8fr)] lg:gap-10">
      <div className="order-2 text-center lg:order-1 lg:text-left">
        <strong className="font-display text-base text-foreground block md:text-lg">2017 Wood Floor of the Year</strong>
        <span className="text-[11px] text-muted-foreground">NWFA award winning craftsmanship</span>
      </div>

      <img
        src={nwfaSeals}
        width={1222}
        height={217}
        loading="eager"
        alt="NWFA Certified Sales Advisor, Installer, Sand and Finisher, and Inspector professional seals"
        className="order-1 col-span-2 mx-auto h-auto w-full max-w-[700px] object-contain lg:order-2 lg:col-span-1"
      />

      <div className="order-3 text-center lg:text-right">
        <strong className="font-display text-base text-foreground block md:text-lg">Licensed Residential Builder</strong>
        <span className="text-[11px] text-muted-foreground">State of Michigan, fully insured</span>
      </div>
    </div>
  </section>
);

export default TrustBar;
